module.exports = __webpack_public_path__ + "img/logo déguster active.140939ab.png";